<template>
    <div v-show="show===true" class="confirm-box-modal-overlay">
        <div class="confirm-box confirmBox pc">
            <p class="confirm-box__copy">{{message}}</p>
            <p class="confirm-box__desc">{{subMessage}}</p>
            <div class="confirm-box__btnwrap">
                <!-- 成功の場合 -->
                <button v-if="!errorFlag" class="forward-btn" @click="hiddenConfirm()">OK</button>
                <!-- エラーの場合 -->
                <button v-if="errorFlag" class="exit-btn" @click="hiddenConfirm()">閉じる</button>
            </div>
        </div>
    </div>
</template>

<script>
import componentModalCenter from '../../js/modules/componentModalCenter.js'// eslint-disable-line
import componentScrollControl from '../../js/modules/componentScrollControl.js'// eslint-disable-line
import $ from 'jquery'// eslint-disable-line

export default {
    name: 'Alert',
    data() {
        return {
            show: false,
        }
    },
    props:{
        message: {
            type: String
        },
        subMessage: {
            type: String
        },
        errorFlag: {
            type: Boolean
        }
    },
    methods: {
        showConfirm() {// eslint-disable-line
            if (this.show === false) {
                this.show = true;
                this.$nextTick(function () {
                    componentScrollControl.no_scroll();
                    componentModalCenter(".confirm-box");
                    document.getElementById('page_top').style.display = 'none';
                })
            }
            // オーバーレイの高さ調整
            if($("html").outerHeight() > window.innerHeight) {
                // スクロールありの場合、htmlの高さを適用
                $(`.confirm-box-modal-overlay`).css("height", `${$("html").outerHeight()}px`);
            } else {
                // スクロールなしの場合、windowの高さを適用
                $(`.confirm-box-modal-overlay`).css("height", `${window.innerHeight}px`);
            }
        },
        hiddenConfirm() {
            componentScrollControl.return_scroll();
            this.show = false;
            this.$emit('confirmFinished');
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
            })
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/modal/Alert.css";
</style>